class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);


class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }
  
  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.footer-js-contents',
      },
      {
        id: 'cart-count-reminder',
        section: 'cart-reminder',
        selector: '#cart-count-reminder',
      },
    ];
  }
  
  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const cartmain = document.getElementById('cart_page-data');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartmain) cartmain.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
          let cartReminder = document.querySelector('#cart-count-reminder');
          this.getSectionsToRender().forEach((section) => {
          if(!cartReminder && section.id === 'cart-count-reminder'){return;}
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
          if(section.id === 'cart-count-reminder'){
            let closeButton = document.querySelector('.btn-cart-reminder__close');
            if(closeButton){
              closeButton.addEventListener('click', function () {
                document.querySelector('.cart-count-reminder').classList.add('hidden__reminder');
              });
            }
            let itemCount = parseInt(elementToReplace.querySelector('.cart-count-reminder__inner').dataset.itemCount);
            let cartReminder = document.querySelector('#cart-count-reminder');
            if(itemCount === 0 && cartReminder){
              cartReminder.classList.add('hidden');
              cartReminder.classList.remove('active');
            }else if(itemCount > 0 && cartReminder){
              cartReminder.classList.remove('hidden');
            }
          }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    if (lineItemError && message !== ''){
      lineItemError.classList.remove('hidden');
    }else{
      lineItemError.classList.add('hidden');
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class FreeShippingBar extends HTMLElement {
  static get observedAttributes() {
    return ["data-total-price"];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    this.threshold = parseFloat(this.dataset.threshold);
    this.shopifyThreshold = Math.round(this.threshold * (Shopify.currency.rate || 1));
    this.totalPrice = parseFloat(this.dataset.totalPrice);
    this._updateMessage();
    this._updateProgressBar();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-total-price" && oldValue !== newValue) {
      this.totalPrice = parseFloat(newValue);
      this._updateMessage();
      this._updateProgressBar();
    }
  }

  _updateMessage() {
    const messageElement = this.querySelector(".shipping-bar__message");
    if (messageElement) {
      messageElement.innerHTML = this.totalPrice >= this.shopifyThreshold
        ? this.getAttribute("reached-message")
        : this.getAttribute("unreached-message");
    }
  }

  _updateProgressBar() {
    let progress = (this.totalPrice / this.shopifyThreshold) * 100;
    progress = Math.min(progress, 100); // Cap progress at 100%
    if (progress > 50) {
      this.classList.add('half-width');
    } else {
      this.classList.remove('half-width');
    }
    this.style.setProperty("--shipping-progress", `${progress}%`);
  }
}

if (!window.customElements.get("free-shipping-bar")) {
  window.customElements.define("free-shipping-bar", FreeShippingBar);
}

class FreeShippingBarCart extends HTMLElement {
  static get observedAttributes() {
    return ["data-total-price"];
  }

  constructor() {
    super();
  }

  connectedCallback() {
    this.threshold = parseFloat(this.dataset.threshold); // 150 RON for free shipping
    this.discountThreshold = parseFloat(this.dataset.discountThreshold); // 199 RON for discount
    this.totalPrice = parseFloat(this.dataset.totalPrice);

    this._updateMessage();
    this._updateProgressBar();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === "data-total-price" && oldValue !== newValue) {
      this.totalPrice = parseFloat(newValue);
      this._updateMessage();
      this._updateProgressBar();
    }
  }

  _updateMessage() {
    const messageElement = this.querySelector(".shipping-bar__message");
    if (!messageElement) return;

    const reachedMessage = this.getAttribute("reached-message") || "";
    const unreachedMessage = this.getAttribute("unreached-message") || "";
    const progressMessage = this.getAttribute("progress-message") || "";

    const remainingForShipping = Math.max(0, Math.ceil((this.threshold - this.totalPrice) / 100));
    const remainingForDiscount = Math.max(0, Math.ceil((this.discountThreshold - this.totalPrice) / 100));

    if (this.totalPrice >= this.discountThreshold) {
      messageElement.innerHTML = reachedMessage;
    } else if (this.totalPrice >= this.threshold) {
      messageElement.innerHTML = progressMessage.replace("{discount}", remainingForDiscount);
    } else {
      messageElement.innerHTML = unreachedMessage.replace("{shipping}", remainingForShipping).replace("{discount}", remainingForDiscount);
    }
  }

  _updateProgressBar() {
    let progress;
    if (this.totalPrice >= this.discountThreshold) {
      progress = 100;
    } else if (this.totalPrice >= this.threshold) {
      let extraProgress = ((this.totalPrice - this.threshold) / (this.discountThreshold - this.threshold)) * 50;
      progress = 50 + extraProgress;
    } else {
      progress = (this.totalPrice / this.threshold) * 50;
    }
    progress = Math.min(progress, 100);
    if(progress >= 45 && progress < 50) {
      progress = 45;
    }
    if(progress >= 95 && progress < 100) {
      progress = 96;
    }
    this.style.setProperty("--shipping-progress", `${progress}%`);
    this._updateCheckMarks();
  }

  _updateCheckMarks() {
    const step1 = this.querySelector(".progress-bar-step-1");
    const step2 = this.querySelector(".progress-bar-step-2");
    const step3 = this.querySelector(".progress-bar-step-3");
  
    if (step1) step1.classList.add("achieved");
    if (step2) step2.classList.toggle("achieved", this.totalPrice >= this.threshold);
    if (step3) step3.classList.toggle("achieved", this.totalPrice >= this.discountThreshold);
  }
}
if (!window.customElements.get("free-shipping-bar-cart")) {
  window.customElements.define("free-shipping-bar-cart", FreeShippingBarCart);
}

function giftWrap(int) {
  var variantId = int.getAttribute("data-id");
  fetch('/cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  }),
  })
  .then(response => response.json())
  .then(data => {
    location.reload();
  }) 
  
}
